<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="h-100">
        <div class="w-100 h-100 p-tb" id="issueUserRateEchart"></div>
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="最近7天数据，按检验时间查询,按缺陷数量排序柏拉图，按缺陷类型分组显示。" placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
export default {
  name: "defect-plato",
  props: {
    beans: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      dataSet: [],
      startCharts: null,
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        if (val && val['total'] != undefined) {
          this.formatData(val);
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    formatData(res) {
      const total = res.total;
      const set = res.list;
      let fold = 0;
      for (let i = 0; i < set.length; i++) {
        const quantity = set[i].quantity;
        fold += quantity;
        let probability = 0;
        let proportion = 0;

        if (fold != 0) {
          probability = (parseInt(((fold / total) * 100) + '', 0));
          proportion = (parseInt(((quantity / total) * 100) + '', 0));
        }
        set[i]['proportion'] = proportion;
        set[i]['probability'] = probability;
      }
      this.dataSet = set;
      this.lineEchart();
    },
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    lineEchart() {
      var lineEchart = this.$echarts.init(
        document.getElementById("issueUserRateEchart")
      );

      var data = this.dataSet;
      const xAxis = [];
      const lineData = [];
      const barData = [];
      data.forEach(item => {
        barData.push(item.quantity);
        xAxis.push(item.title);
        lineData.push(item.probability);
      });

      var option = {
        title: {
          text: "缺陷柏拉图(一周)",
          left: "10",
          textStyle: {
            color: "#ffffff",
            fontSize: this.fontSize(0.30),
          },
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        legend: {
          data: ["缺陷数量", "累计百分比"],
          left: "40%",
          textStyle: {
            color: "#ffffff", //字体颜色
            fontSize: this.fontSize(0.15),
          },
          itemGap: 2,
          show: true
        },
        grid: {
          left: "3%",
          right: "10",
          bottom: "0",
          top: "25%",
          y2: 40,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              interval: 0,
              // rotate: 15,
              textStyle: {
              color: "#ffffff", //字体颜色
              fontSize: this.fontSize(0.20),
            }
            },
           
          },
        ],
        yAxis: [
          {
            name: '缺陷数量',
            nameTextStyle: {
              fontSize: this.fontSize(0.20),
            },
            type: "value",
            min: 0,
            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            name: '累计百分比',
            nameTextStyle: {
              fontSize: this.fontSize(0.20),
            },
            type: "value",
            min: 0,
            axisLabel: {
              formatter: "{value} %",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          }
        ],
        series: [
          {
            color: ["#3398DB"],
            type: "bar",
            name: "缺陷数量",
            data: barData,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: 'inside', // 在上方显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: this.fontSize(0.20),
                  },
                },
              },
            },
          },
          {
            color: ["red"],
            type: "line",
            name: "累计百分比",
            stack: "total",
            barMaxWidth: "10%",
            data: lineData,
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: this.fontSize(0.20),
                  },
                  formatter: "{c} %",
                },
              },
            },
          }
        ],
      };

      lineEchart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });

      if (this.startCharts) {
        clearInterval(this.startCharts);
      }

      var index = 0; //显示tooltip,播放所在下标
      this.startCharts = setInterval(function () {
        lineEchart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= data.length) {
          index = 0;
        }
      }, 2000);
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


<style scoped>
.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/nok/component/defect-plato.vue